import React from 'react';

const EmDash = () => (
    <span>-</span>
);

export default EmDash;